/* eslint-disable no-unused-vars */
import _ from 'lodash'

export const getSubmissionStatus = (status: TAnimeSubscription.TSubmissionStatus) => {
  const obj: { [x in TAnimeSubscription.TSubmissionStatus]: string } = {
    WaitingForApproval: '承認待ち',
    Approved: '承認済み',
    Rejected: '非承認',
    WaitingForSubmission: '入稿待ち',
    Draft: '下書き',
    Cancelled: 'キャンセル',
    '': '全て'
  }
  return obj[status]
}

export const appendParams = (url: string, paramObj: Object) => {
  let finalUrl = url
  // Picking the boolean value
  const pickTheBoolean = _.pickBy(paramObj, _.isBoolean)
  // because of the identity remove the falsy value (include false), we add the false value to root obj again
  const removedEmptyVal = { ..._.pickBy(paramObj, _.identity), ..._.pickBy(paramObj, (value, key) => key === 'Status' && !_.isString(value)), ...pickTheBoolean }
  Object.keys(removedEmptyVal).forEach((key, index) => {
    const val = paramObj[key as keyof typeof paramObj] as any
    if (val !== '') {
      const startString = index === 0 ? '?' : '&'
      finalUrl += `${startString}${key}=${val}`
    }
  })
  return finalUrl
}

export const getOPTIntroductionVideoServiceOrderStatus = (status: TOPTIntroductionVideoService.TOrderStatus) => {
  const obj: { [x in TOPTIntroductionVideoService.TOrderStatus]: string } = {
    New: '新着',
    Doing: '対応中',
    Done: '対応済',
    Cancelled: 'キャンセル',
    Temp: '一時的',
    '': '全て'
  }
  return obj[status]
}

export const getOPTInitialSetupServiceOrderStatus = (status: TOPTInitialSetupService.TOrderStatus) => {
  const obj: { [x in TOPTInitialSetupService.TOrderStatus]: string } = {
    New: '新着',
    Doing: '対応中',
    Done: '対応済',
    Cancelled: 'キャンセル',
    Temp: '一時的',
    '': '全て'
  }
  return obj[status]
}

export const getCustomerEKYCStatus = (status: TUserManagement.TUserKYCStatus) => {
  const obj: { [x in TUserManagement.TUserKYCStatus]: string } = {
    approved: '承認',
    denied: '否認',
    incomplete: '不備',
    onhold: '保留',
    yet: '事務局確認待ち',
    '': '事務局確認待ち'
  }
  return obj[status]
}

export const getWebNotificationTarget = (status: TWebNotificationManagement.TWebNotificationTarget) => {
  const obj: { [x in TWebNotificationManagement.TWebNotificationTarget]: string } = {
    TopTitle: 'ユーザーweb向け(ヘッダー）',
    TopHeader: 'ユーザーweb向け(帯）'
  }
  return obj[status]
}

export const getStoreTag = (tag: TStoreManagement.StoreTag) => {
  const obj: { [x in TStoreManagement.StoreTag]: string } = {
    None: '',
    Contracted: '契約済店舗',
    NotRecommendedForVideo: '応援動画非推奨店舗',
    NonContracted: '未契約店舗'
  }
  return obj[tag]
}

export const getStoreBillingBy = (item: TStoreManagement.BillingBy) => {
  const obj: { [x in TStoreManagement.BillingBy]: string } = {
    Store: '店舗',
    HeadQuarter: '本部（請求書払い可）',
    ADC: 'ADC'
  }
  return obj[item]
}

export const getStoreBillingMethod = (item: TStoreManagement.BillingMethod) => {
  const obj: { [x in TStoreManagement.BillingMethod]: string } = {
    VideoReplayFee: 'A 応援動画再生課金',
    MouseClickFee: 'B クリック課金'
  }
  return obj[item]
}

export const getStoreType = (item: TStoreManagement.StoreType) => {
  const obj: { [x in TStoreManagement.StoreType]: string } = {
    Restaurant: '店舗',
    OnlineShopping: '通販'
  }
  return obj[item]
}

export const getGmbMembership = (item: TStoreManagement.GmbMembership) => {
  const obj: { [x in TStoreManagement.GmbMembership]: string } = {
    None: '',
    Free: '無料',
    Paid: '有料'
  }
  return obj[item]
}
